import { createContext } from 'react';

const JourneyCardContext = createContext({});

export default JourneyCardContext;
